import { __extends } from "tslib";
var CustomError = (function (_super) {
    __extends(CustomError, _super);
    function CustomError(m, name) {
        var _this = _super.call(this, m) || this;
        _this.name = name;
        Object.setPrototypeOf(_this, CustomError.prototype);
        return _this;
    }
    return CustomError;
}(Error));
export { CustomError };
//# sourceMappingURL=customError.js.map